/**
 * 自定义首页默认配置参数
 */

import randomString from 'random-string'
import cmsEntryData from './cmsEntryData'

const IMG_BASE_URL = '//img.zhutui.cn'
const WOL_BASE_URL = '//jk.zhutui.cn/cms/public/images/cms_tpl/wolverine/theme1'

export default function() {
  return {
    using: true,
    preview_img: '//img.zhutui.cn/20201028/8da870ab00d2393.png',
    name: '经典',
    id: randomString({ length: 8 }),

    // 顶部导航栏
    navigate: {
      background: '#FFFFFF',
      search_background: '#EFF1F3',
      link_color: '#8D9299',
      links: [],
    },

    // 底部导航栏
    tabbar: {
      background: '#FFFFFF',
      color: '#B0BEC5',
      active_color: '#FF6766',
      list: cmsEntryData.filterAuthority([
        {
          active_icon: `${IMG_BASE_URL}/20200407/15862453381709.png`,
          icon: `${IMG_BASE_URL}/20200407/15862453458239.png`,
          title: '首页',
          href: '/',
          href_title: '首页',
        },
        {
          active_icon: `${IMG_BASE_URL}/20200407/15862453512107.png`,
          icon: `${IMG_BASE_URL}/20200407/15862453554043.png`,
          title: '分类',
          href: '/category',
          href_title: '全部分类',
        },
        {
          active_icon: `${IMG_BASE_URL}/20200407/15862453611898.png`,
          icon: `${IMG_BASE_URL}/20200407/15862453642935.png`,
          title: '爆款排行',
          href: '/ranking',
          href_title: '爆款排行',
        },
        {
          active_icon: `${IMG_BASE_URL}/20200407/15862453695939.png`,
          icon: `${IMG_BASE_URL}/20200407/15862453722629.png`,
          title: '我的',
          href: '/user',
          href_title: '个人中心',
        },
      ]),
    },

    // 首页布局
    layout: [

      // 轮播图
      {
        type: 'TplSwipe',
        // type_name: '轮播图',
        props: {
          show_global: true,
          list: [],
        },
      },

      // 精选导航
      {
        type: 'Wolverine',
        // type_name: '精选导航',
        props: {
          current: 0,
          total_page: 1,
          list: cmsEntryData.filterAuthority([
            {
              id: randomString({ length: 8 }),
              title: '人工精选',
              icon: `${WOL_BASE_URL}/ic_home_rgjx@3x.png`,
              href: '/channel/1',
              href_title: '人工精选',
            },
            {
              id: randomString({ length: 8 }),
              title: '9块9',
              icon: `${WOL_BASE_URL}/ic_home_99@3x.png`,
              href: '/channel/0',
              href_title: '9块9',
            },
            {
              id: randomString({ length: 8 }),
              title: '聚划算',
              icon: `${WOL_BASE_URL}/ic_home_jhs@3x.png`,
              href: '/category/tag_1',
              href_title: '聚划算',
            },
            {
              id: randomString({ length: 8 }),
              title: '京东',
              icon: `${WOL_BASE_URL}/ic_home_jd@3x.png`,
              href: '/jdList',
              href_title: '京东',
            },
            // {
            //   id: randomString({ length: 8 }),
            //   title: '拼多多',
            //   icon: `${WOL_BASE_URL}/ic_home_pdd@3x.png`,
            //   href: '/pddList',
            //   href_title: '拼多多',
            // },
            {
              id: randomString({ length: 8 }),
              title: '邀请好友',
              icon: `${WOL_BASE_URL}/ic_home_yqhy@3x.png`,
              href: '/invitation',
              href_title: '邀请注册',
            },
            {
              id: randomString({ length: 8 }),
              title: '个人中心',
              icon: `${WOL_BASE_URL}/ic_home_grzx@3x.png`,
              href: '/user',
              href_title: '个人中心',
            },
            {
              id: randomString({ length: 8 }),
              title: '联系客服',
              icon: `${WOL_BASE_URL}/ic_home_kf@3x.png`,
              href: '/kf',
              href_title: '联系客服',
            },
          ]),
        },
        hover_view: {
          arrowKey: 'current', // 控制左右箭头的的字段
          arrowMaxKey: 'total_page',
        },
      },

      // 通知
      {
        type: 'Notice', // 组件类型名称
        // type_name: '通知', // 组件中文名称

        props: { // 直接用于v-bind绑定 mod和edit 组件关系

        },
      },

      // 拼图
      // {
      //   type: 'Puzzle', // 组件类型名称
      //   // type_name: '拼图',

      //   props: {
      //     list: cmsEntryData.filterAuthority([
      //       {
      //         size: '2x1',
      //         title: '聚划算',
      //         sub: '热卖品牌正…',
      //         href: '/category/tag_1',
      //         href_title: '聚划算',
      //         src: 'https://jk.zhutui.cn/cms/public/images/c3.png',
      //       },
      //       {
      //         size: '2x1',
      //         title: '购抢购',
      //         sub: '低价让利促销',
      //         href: '/category/tag_0',
      //         href_title: '淘抢购',
      //         src: 'https://jk.zhutui.cn/cms/public/images/c1.png',
      //       },
      //       {
      //         size: '2x1',
      //         title: '限时秒杀',
      //         sub: '限时限量',
      //         href: '/xsms',
      //         href_title: '超级秒杀',
      //         src: 'https://jk.zhutui.cn/cms/public/images/c5.png',
      //       },
      //       {
      //         size: '2x1',
      //         title: '9块9包邮',
      //         sub: '省钱不只是一点点',
      //         href: '/channel/0',
      //         href_title: '9块9',
      //         src: 'https://jk.zhutui.cn/cms/public/images/c4.png',
      //       },
      //     ]),
      //   },
      // },

      // 限时抢购
      cmsEntryData.validateAuthority('限时抢购') ? ({
        type: 'PluginXSQG',
        // type_name: '限时抢购',
        props: {},
      }) : undefined,


      // 商品列表
      {
        type: 'ProductList', // 组件类型名称
        // type_name: '商品模块', // 组件中文名称

        props: { // 直接用于v-bind绑定 mod和edit 组件关系
          title: '为你推荐', // 标题
          label: '默认',
          api_name: 'cms_items_list', // 接口名称，数据列表可能涉及到多个列表接口（拼多多、京东）
          params: '', // 接口的请求参数
        },
      },
    ].filter((item) => !!item),

  }
}
